import i18n from 'i18n-js';
import * as Yup from 'yup';
import moment from 'moment';
import { formatAmount } from 'utils';
import { MAX_AMOUNT } from 'constants';

const PROMO_CODE_MIN_VALUE = 0.01;
const PROMO_CODE_LENGTH = 20;

const initialValues = (promoCode, clone = false) => ({
  invoice_item_type_id: promoCode?.invoice_item_type_id || null,
  code: clone ? '' : promoCode?.code || '',
  ...(promoCode ? { amount: formatAmount(promoCode?.amount) } : {}),
  description:
    clone && promoCode?.description
      ? `Copy of ${promoCode?.description}`
      : promoCode?.description || '',
  start_time: promoCode?.start_time || '',
  expiration_time: promoCode?.expiration_time
    ? moment(promoCode?.expiration_time).subtract(1, 'days').format()
    : '',
  is_enabled: promoCode?.is_enabled || false,
});

const formSchema = () =>
  Yup.object().shape({
    invoice_item_type_id: Yup.number()
      .typeError(i18n.t('common.required_field'))
      .required(i18n.t('common.required_field')),
    code: Yup.string()
      .test(
        'len',
        i18n.t('common.max_length', { len: PROMO_CODE_LENGTH }),
        (code) => code?.length <= PROMO_CODE_LENGTH
      )
      .required(i18n.t('common.required_field')),
    amount: Yup.number()
      .min(
        PROMO_CODE_MIN_VALUE,
        i18n.t('common.custom_min_value', { min_value: PROMO_CODE_MIN_VALUE })
      )
      .max(
        MAX_AMOUNT,
        i18n.t('common.max_value', {
          max_value: new Intl.NumberFormat().format(MAX_AMOUNT),
        })
      )
      .typeError(i18n.t('common.type_error'))
      .when('is_enabled', {
        is: (is_enabled) => is_enabled,
        then: Yup.number().required(i18n.t('common.required_field')),
      }),
    description: Yup.string().nullable(),
    start_time: Yup.string()
      .nullable()
      .when('is_enabled', {
        is: (is_enabled) => is_enabled,
        then: Yup.string().required(i18n.t('common.required_field')),
      }),
    expiration_time: Yup.string().nullable(),
    is_enabled: Yup.boolean().required(i18n.t('common.required_field')),
  });

export { initialValues, formSchema };
